import { EOfficeType } from 'shared/types/filters';

export const EXCLUDED_RENT_OFFICE_TYPES = [EOfficeType.RentalBusiness, EOfficeType.ReadyBusiness];
